import { HttpStatus } from '../api/constants';

class Utilities {
  static isEmpty(string) {
    return string === null || string === undefined || string.length === 0;
  }

  static isUnauthorizedRequest(error) {
    if (Utilities.isEmpty(error)) return false;
    const { response } = error;
    if (!Utilities.isEmpty(response)) {
      const { status } = response;
      return status === HttpStatus.unauthorized;
    }
    return false;
  }
}

export default Utilities;
